import { createCustomField, deleteCustomField, getCustomFields, updateCustomField } from "../api/customField";
import { CustomField, CustomFieldDTO } from "../types/customField";

export async function fetchCustomFieldPagedData(params?: PagedRequestParams): Promise<PagedResult<CustomField>> {
    const res = await getCustomFields(params)

    const customFields = res.items.map(dto => dtoToCustomField(dto))

    return {
        ...res,
        items: customFields
    }
}

export async function manageCreateCustomField(data: CustomField): Promise<ErrorMessage | CustomField> {
    const res = await createCustomField(customFieldToDTO(data))

    if (res && 'errorCode' in res) {
        return res
    }

    return dtoToCustomField(res)
}

export async function manageUpdateCustomField(data: CustomField): Promise<ErrorMessage | CustomField> {
    const res = await updateCustomField(customFieldToDTO(data))

    if (res && 'errorCode' in res) {
        return res
    }

    return dtoToCustomField(res)
}

export async function manageDeleteCustomField(id: string): Promise<ErrorMessage | void> {
    const res = await deleteCustomField(id)

    if (res) {
        return res
    }
}

function dtoToCustomField(dto: CustomFieldDTO): CustomField {
    return {
        id: dto.id,
        title: dto.title,
        description: dto.description,
        email: dto.email,
        enabled: dto.enabled
    }
}

function customFieldToDTO(customField: CustomField): CustomFieldDTO {
    return {
        id: customField.id,
        title: customField.title,
        description: customField.description,
        email: customField.email,
        enabled: customField.enabled
    }
}